import { FIELD_TYPE_REGISTRY } from "./registryMetadata";

const SEMANTIC_TO_FIELD_TYPE = {};

Object.values(FIELD_TYPE_REGISTRY).forEach((entry) => {
  (entry.semanticAliases || []).forEach((alias) => {
    const key = String(alias || "").toUpperCase();
    if (key && !SEMANTIC_TO_FIELD_TYPE[key]) {
      SEMANTIC_TO_FIELD_TYPE[key] = entry.key;
    }
  });
});

export const semanticTypeToFieldType = (semanticType) => {
  const key = String(semanticType || "").toUpperCase();
  return SEMANTIC_TO_FIELD_TYPE[key] || "STRING";
};

export const getSemanticTypeMap = () => ({ ...SEMANTIC_TO_FIELD_TYPE });
